import {
  Image,
  Input,
  Modal,
  ModalBody,
  ModalContent,
  ModalHeader,
} from "@nextui-org/react";
import React, { useEffect, useState } from "react";
import closeIcon from "../../Assets/popup/cross-square.svg";
import magnifier from "../../Assets/my-fronds/magnifier.svg";
import frondImg from "../../Assets/my-fronds/frond/category/other.svg";
import axios from "axios";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";

export default function AppSearch({ isOpen, onClose }) {
  const handleClose = () => {
    onClose();
  };

  const authToken = localStorage.getItem("token");
  const [query, setQuery] = useState("");
  const [results, setResults] = useState({
    fronds: [],
    hashtags: [],
    posts: [],
    library: [],
  });
  const [selectedTab, setSelectedTab] = useState("All");

  const getSearchResults = async () => {
    try {
      const { data } = await axios.get(
        `/search`,
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
          params: { query: query },
        }
      );
      setResults(data || { fronds: [], hashtags: [], posts: [], library: [] });
    } catch (error) {
      toast(error?.response?.data?.message, {
        autoClose: 1500,
        position: "bottom-right",
        hideProgressBar: true,
        className: "rounded-4xl custom-toast error-toast",
      });
    }
  };

  useEffect(() => {
    const handler = setTimeout(() => {
      if (query.trim() !== "") {
        getSearchResults();
      }
    }, 500);
    return () => clearTimeout(handler);
  }, [query]);

  const renderTabButton = (name) => (
    <button
      onClick={() => setSelectedTab(name)}
      className={`py-1.5 px-2.5 flex items-center justify-center text-sm rounded-full flex-1 ${
        selectedTab === name
          ? "bg-mainGradiant text-white"
          : "bg-lightWhite text-cardGrayColor"
      }`}
    >
      {name}
    </button>
  );

  // Helper function to render tags for a frond
  const renderFrondTags = (tags) => {
    if (!tags || tags.length === 0) return null;
    
    return (
      <div className="flex flex-wrap gap-1 mt-1">
        {tags.map((tag, index) => (
          <span
            key={index}
            className="bg-blue-100 text-blue-800 text-xs px-2 py-0.5 rounded-full"
          >
            #{typeof tag === 'string' ? tag : tag.tag || tag.name || tag}
          </span>
        ))}
      </div>
    );
  };

  return (
    <Modal
      isOpen={isOpen}
      onOpenChange={() => onClose()}
      placement="center"
      backdrop="opaque"
      size="4xl"
      classNames={{
        backdrop: "z-[9999]",
        wrapper: "z-[99999]",
        footer: "justify-center items-center py-5",
        body: "border-b-1 border-solid border-grayBorder pt-2 pb-4 overflow-auto",
        closeButton: "hidden",
        base: "p-5 search-modal",
      }}
      hideCloseButton={true}
    >
      <ModalContent>
        {(onClose) => (
          <>
            <ModalHeader className="flex items-center justify-between">
              <h2 className="text-textColor font-bold text-lg">Search</h2>
              <button onClick={handleClose} aria-label="Close">
                <img src={closeIcon} alt="Close" className="w-6 h-6" />
              </button>
            </ModalHeader>
            <ModalBody>
              <Input
                type="text"
                variant="bordered"
                placeholder="Search frond..."
                startContent={<img src={magnifier} alt="search" />}
                onChange={(e) => setQuery(e.target.value)}
                value={query}
                classNames={{
                  base: "",
                  input:
                    "border-none px-[22px] text-darkBlue text-base search-input",
                  innerWrapper: "h-[39px] px-[15px]",
                  inputWrapper:
                    "border-[0.86px] p-0 border-solid bg-lightWhite search-input-box no-focus border-lightWhite rounded-[20px] h-[39px]",
                }}
              />

              <div className="flex items-center gap-2.5 lg:w-[60%] sm:w-[80%] mx-auto mt-3 mb-3">
                {renderTabButton("All")}
                {renderTabButton("Fronds")}
                {renderTabButton("Hashtags")}
                {renderTabButton("Posts")}
                {renderTabButton("Library")}
              </div>

              {(selectedTab === "All" || selectedTab === "Fronds") && (
                <div className="mb-5">
                  <div className="flex items-center gap-2.5 mb-3">
                    <h3 className="text-cardGrayColor text-sm">Fronds</h3>
                    <div className="flex-1 h-[1px] bg-grayBorder"></div>
                  </div>
                  <div className="flex flex-col gap-4">
                    {results.fronds?.length > 0 ? (
                      results.fronds.map((item) => (
                        <div key={item.id} className="flex flex-col gap-2">
                          <div className="flex gap-3 items-center">
                            <Image src={frondImg} alt="Frond" className="w-10 h-10" />
                            <Link
                              onClick={handleClose}
                              to={`/frond/about/${item?.id}`}
                              className="text-textColor text-sm font-medium hover:text-blue-600"
                            >
                              {item.title}
                            </Link>
                          </div>
                          
                          {/* Display frond tags */}
                          {item.tags && renderFrondTags(item.tags)}
                          
                          {/* Display frond description if available */}
                          {item.description && (
                            <p className="text-gray-600 text-xs ml-13 pl-13">
                              {item.description.substring(0, 100)}
                              {item.description.length > 100 ? '...' : ''}
                            </p>
                          )}
                        </div>
                      ))
                    ) : (
                      <p className="text-textColor text-sm">No fronds found.</p>
                    )}
                  </div>
                </div>
              )}

              {(selectedTab === "All" || selectedTab === "Hashtags") && (
                <div className="mb-5">
                  <div className="flex items-center gap-2.5 mb-3">
                    <h3 className="text-cardGrayColor text-sm">Hashtags</h3>
                    <div className="flex-1 h-[1px] bg-grayBorder"></div>
                  </div>
                  <div className="flex flex-col gap-4">
                    {results.hashtags?.length > 0 ? (
                      results.hashtags.map((item) => (
                        <div key={item.id} className="flex flex-col gap-2">
                          <div className="flex gap-3 items-center">
                            <div className="flex items-center justify-center w-6 h-6 rounded-full bg-offWhite text-[#787FB9] text-sm font-bold">
                              #
                            </div>
                            <Link
                              onClick={handleClose}
                              to={"/community"}
                              className="text-textColor text-sm hover:text-blue-600"
                            >
                              #{item.tag}
                            </Link>
                          </div>
                          
                          {/* Show count of posts with this hashtag if available */}
                          {item.count && (
                            <p className="text-gray-500 text-xs ml-9">
                              {item.count} {item.count === 1 ? 'post' : 'posts'}
                            </p>
                          )}
                        </div>
                      ))
                    ) : (
                      <p className="text-textColor text-sm">
                        No hashtags found.
                      </p>
                    )}
                  </div>
                </div>
              )}

              {/* If you want to show fronds that have matching hashtags in the hashtag section */}
              {selectedTab === "Hashtags" && results.fronds?.length > 0 && (
                <div className="mb-5 mt-3">
                  <div className="flex items-center gap-2.5 mb-3">
                    <h3 className="text-cardGrayColor text-sm">Related Fronds</h3>
                    <div className="flex-1 h-[1px] bg-grayBorder"></div>
                  </div>
                  <div className="flex flex-col gap-4">
                    {results.fronds
                      .filter(frond => frond.tags && frond.tags.length > 0)
                      .map((item) => (
                        <div key={`related-${item.id}`} className="flex flex-col gap-1">
                          <div className="flex gap-3 items-center">
                            <Image src={frondImg} alt="Frond" className="w-8 h-8" />
                            <Link
                              onClick={handleClose}
                              to={`/frond/about/${item?.id}`}
                              className="text-textColor text-sm"
                            >
                              {item.title}
                            </Link>
                          </div>
                          {item.tags && (
                            <div className="flex flex-wrap gap-1 ml-11">
                              {item.tags.map((tag, index) => (
                                <span
                                  key={index}
                                  className="bg-gray-100 text-gray-600 text-xs px-2 py-0.5 rounded-full"
                                >
                                  #{typeof tag === 'string' ? tag : tag.tag || tag.name || tag}
                                </span>
                              ))}
                            </div>
                          )}
                        </div>
                      ))}
                  </div>
                </div>
              )}

              {(selectedTab === "All" || selectedTab === "Posts") && (
                <div className="mb-5">
                  <div className="flex items-center gap-2.5 mb-3">
                    <h3 className="text-cardGrayColor text-sm">Posts</h3>
                    <div className="flex-1 h-[1px] bg-grayBorder"></div>
                  </div>
                  <div className="flex flex-col gap-4">
                    {results.posts?.length > 0 ? (
                      results.posts.map((item) => (
                        <Link
                          onClick={handleClose}
                          to={"/community"}
                          key={item.id}
                          className="flex flex-col gap-1"
                        >
                          <span className="text-textColor text-sm">
                            {item.content}
                          </span>
                          {/* Show post hashtags if available */}
                          {item.hashtags && (
                            <div className="flex flex-wrap gap-1">
                              {item.hashtags.map((tag, index) => (
                                <span key={index} className="text-blue-500 text-xs">
                                  #{typeof tag === 'string' ? tag : tag.tag || tag}
                                </span>
                              ))}
                            </div>
                          )}
                        </Link>
                      ))
                    ) : (
                      <p className="text-textColor text-sm">No posts found.</p>
                    )}
                  </div>
                </div>
              )}

              {(selectedTab === "All" || selectedTab === "Library") && (
                <div>
                  <div className="flex items-center gap-2.5 mb-3">
                    <h3 className="text-cardGrayColor text-sm">Library</h3>
                    <div className="flex-1 h-[1px] bg-grayBorder"></div>
                  </div>
                  <div className="flex flex-col gap-4">
                    {results.library?.length > 0 ? (
                      results.library.map((item) => (
                        <div key={item.id} className="flex flex-col gap-2">
                          <div className="flex gap-3 items-center">
                            {item.video_url ? (
                              <video
                                src={item.video_url}
                                controls
                                className="rounded-md w-[200px]"
                              ></video>
                            ) : (
                              <div className="w-[200px] h-[100px] bg-gray-200 rounded-md flex items-center justify-center">
                                <span className="text-gray-500 text-xs">No video</span>
                              </div>
                            )}
                            <Link
                              onClick={handleClose}
                              to={"/library"}
                              className="text-textColor text-sm font-bold hover:text-blue-600"
                            >
                              {item.title}
                            </Link>
                          </div>
                          {/* Show library item tags if available */}
                          {item.tags && (
                            <div className="flex flex-wrap gap-1 ml-[216px]">
                              {item.tags.map((tag, index) => (
                                <span
                                  key={index}
                                  className="bg-gray-100 text-gray-600 text-xs px-2 py-0.5 rounded-full"
                                >
                                  #{typeof tag === 'string' ? tag : tag.tag || tag.name || tag}
                                </span>
                              ))}
                            </div>
                          )}
                        </div>
                      ))
                    ) : (
                      <p className="text-textColor text-sm">
                        No library items found.
                      </p>
                    )}
                  </div>
                </div>
              )}
            </ModalBody>
          </>
        )}
      </ModalContent>
    </Modal>
  );
}